<template>
    <div class="w-100 d-flex justify-content-center">
        <div class="video-container">
            <video-player
              ref="player"
              :options="playerOptions" 
              :playsinline="true"
              class="video-player"
            />
        </div>
    </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  name: 'VideoPlayer',
  components: {
    videoPlayer
  },

  props: {
    source: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    playerOptions() {
      return {
        ...this.options,
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: this.source
        }]
      }
    }
  },

  watch: {
    source(newSource) {
      if (this.$refs.player) {
        this.$refs.player.player.src([{
          type: 'video/mp4',
          src: newSource
        }])
      }
    }
  },

  beforeDestroy() {
    if (this.$refs.player) {
      this.$refs.player.dispose()
    }
  }
}
</script>

<style scoped>
.video-container {
  width: 85%;
}

.video-player {
  width: 100%;
}

:deep(.video-js) {
  width: 100%;
}
</style>